import { render } from "./TextElement.vue.js?vue&type=template&id=4094c7b8&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=template&id=4094c7b8&scoped=true"
import script from "./TextElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=script&lang=js"

import "./TextElement.vue.scss?vue&type=style&index=0&id=4094c7b8&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=style&index=0&id=4094c7b8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4094c7b8"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/TextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4094c7b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4094c7b8', __exports__)) {
    api.reload('4094c7b8', __exports__)
  }
  
  module.hot.accept("./TextElement.vue.js?vue&type=template&id=4094c7b8&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElement.vue?vue&type=template&id=4094c7b8&scoped=true", () => {
    api.rerender('4094c7b8', render)
  })

}


export default __exports__